import { gql } from '@apollo/client'

export const IS_FLEXIBLE_PRORATA_MANAGEMENT_ENABLED = gql`
  query IsFlexibleProrataManagementEnabled($country: Country!) {
    isFlexibleProrataManagementEnabled(country: $country)
  }
`

export const FLEXIBLE_BONUS_BY_EMPLOYEE_ID_IN_AS_MEETING = gql`
  query FindBonusByEmployeeIdInAppraisalSeasonOfMeeting($employeeId: HashedId!, $meetingId: HashedId!) {
    findBonusByEmployeeIdInAppraisalSeasonOfMeeting(employeeId: $employeeId, meetingId: $meetingId) {
      id
      bonusAmount
      bonusStatus
      appraisalSeasonId
      contractId
      contractCurrency
    }
  }
`

export const PAST_YEAR_FLEXIBLE_BONUS_BY_EMPLOYEE_ID_AND_MEETING = gql`
  query FindPastYearFlexibleBonusByEmployeeIdAndMeetingId($employeeId: HashedId!, $meetingId: HashedId!) {
    findPastYearFlexibleBonusByEmployeeIdAndMeetingId(employeeId: $employeeId, meetingId: $meetingId) {
      id
      bonusAmount
      bonusStatus
      appraisalSeasonId
      contractId
      contractCurrency
    }
  }
`

export const EDIT_FLEXIBLE_BONUS_BY_EMPLOYEE_ID = gql`
  mutation EditFlexibleBonusByEmployeeId($bonusAmount: Float!, $employeeId: HashedId!, $meetingId: HashedId!) {
    editFlexibleBonusByEmployeeId(bonusAmount: $bonusAmount, employeeId: $employeeId, meetingId: $meetingId)
  }
`
